// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2PlFr","title":"Info_title__2wZib","links":"Info_links__18XmC","link":"Info_link__2rrM7","logo":"Info_logo__ddvtB"};